<div [formGroup]="form">
  <label [for]="settings.idName" [ngClass]="{ 'text-danger': errorMessage }">
    {{ settings.label }}
  </label>
  <tooltip
    [title]="'Enter Your ' + settings.label"
    placement="right"
    delay="200"
  ></tooltip>
  <input
    type="text"
    [name]="settings.name"
    [autocomplete]="settings.autocomplete"
    [class]="settings.className"
    [readonly]="settings.readonly"
    [id]="settings.idName"
    [placeholder]="settings.placeholder"
    [ngClass]="{ 'border-danger': errorMessage }"
    [formControlName]="settings.formControlName"
    (change)="valueChange()"
    [value]="settings.value"
    (paste)="onPaste($event, '')"
    (focus)="onFocusEvent($event)"
    (click)="onClickEvent($event)"
    (blur)="onBlurEvent($event)"
    (keyup.enter)="onEnterEvent($event)"
  />
  <p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
</div>
